import { FC, ReactNode, useEffect, useState } from 'react';
//
import { useRouter } from 'src/routes/hook';
// routes
import { paths } from 'src/routes/paths';
//
import { SplashScreen } from 'src/components/loading-screen';
import useFetcher, { endpoints } from 'src/utils/axios';
import { useBoolean } from 'src/hooks/use-boolean';

interface CheckConsentProviderProps {
  children: ReactNode;
}

export const CheckConsentProvider: FC<CheckConsentProviderProps> = ({ children }) => {
  const hasConsent = useBoolean(true);
  const { fetchData } = useFetcher();
  const router = useRouter();

  const isLoading = useBoolean(true);

  useEffect(() => {
    fetchData(endpoints.consent.getUserConsent)
      .then((res) => {
        if (res) {
          hasConsent.onTrue();
          isLoading.onFalse();
        } else {
          hasConsent.onFalse();
          isLoading.onFalse();
        }
      })
      .catch(() => {
        hasConsent.onFalse();
        isLoading.onFalse();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading.value) {
    return <SplashScreen />;
  }

  if (!hasConsent.value) {
    const searchParams = new URLSearchParams({
      returnTo: window.location.pathname,
      params: window.location.search,
    }).toString();

    router.push(paths.auth.firebase.manageConsent, searchParams || '');
    return null;
  }

  return <>{children}</>;
};
